import Vue from 'vue'

Vue.directive('focus', {
  inserted: function (el, { value }) {
    if (value) {
      el.focus()
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/focus/index.js